import type React from "react";
import { useCallback, useRef, useState } from "react";
import type {
  NativeSyntheticEvent,
  TextInput,
  TextInputFocusEventData,
} from "react-native";
import { FormLabel } from "./FormLabel";
import { Input, type InputProps } from "./InputNew";

export const FormInput: React.FC<InputProps & { label: string }> = ({
  label,
  onBlur,
  onFocus,
  onChangeText,
  ...inputProps
}) => {
  const [focused, setFocused] = useState(false);
  const [text, setText] = useState(inputProps.defaultValue);
  const ref = useRef<TextInput>(null);

  const handleBlur = useCallback(
    (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
      setFocused(false);
      onBlur?.(e);
    },
    [onBlur],
  );

  const handleFocus = useCallback(
    (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
      setFocused(true);
      onFocus?.(e);
    },
    [onFocus],
  );

  const handleChangeText = useCallback(
    (newText: string) => {
      onChangeText?.(newText);
      setText(newText);
    },
    [onChangeText],
  );

  const labelActive = !!(focused || text || inputProps.defaultValue);

  return (
    <FormLabel
      label={label}
      labelActive={labelActive}
      onLabelPress={() => ref.current?.focus()}
    >
      <Input
        {...inputProps}
        ref={ref}
        onChangeText={handleChangeText}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
    </FormLabel>
  );
};
